var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ms-auto w-md-auto mt-2"},[_c('button',{staticClass:"btn btn-red claim-identifier",on:{"click":function($event){return _vm.verifyPage()}}},[_vm._v(" Díj újraszámolása ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }